// Application shell. React Router (Step 19) owns the screen surface
// from here on; transitions live in src/routes.tsx.

import { useApplyBrandingColors, useApplyPWABranding } from "@/lib/branding";
import { AppRouter } from "@/routes";

export function App() {
  // Push the tenant's palette into :root CSS vars on first branding
  // fetch. global.css carries ICS defaults until then, so the page
  // never flashes uncoloured.
  useApplyBrandingColors();
  useApplyPWABranding();
  return <AppRouter />;
}
